import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {generateRandomPageKey, generateUUID2, getImagePathWithTheme} from "../../utils";
import {EVENT_SWITCH_HOME_LIST_MENU, FILTER_TAG_NO_TAGS, FROM_LIBRARY, MENU_SEPARATOR} from "../../Const";
import {postMessage} from "../../common/event";
import { Button, Dropdown } from "antd";
import { t } from "i18next";
import {getNoteList} from "@model/note";
import {getTagList} from "@model/tag";
let mArrayTags:any = [];

const ProjectTagFilter = forwardRef((props:{margin:any,onRefreshData:any,onTagSelected:any},ref)=>{
    useImperativeHandle(ref,()=>({
        onResetTag:onResetTag
    }))
    const [arrayTags,setArrayTags] = useState<any>([]);
    const [selectTag,setSelectTag] = useState(null);
    const [isTagFilterOpened, setIsTagFilterOpened] = useState(false);
    const [arrayProjectDatas,setArrayProjectDatas] = useState([]);

    const mSelectTag = useRef<any>(null);

    useEffect(() => {
        refreshProjectAndTag();

        const randomId = generateRandomPageKey()
        //需要刷新的tag.
        window.refreshList['projectTagFliter_updateWhenTag_'+randomId] = refreshProjectAndTag;

        return ()=>{
            delete window.refreshList['canvasListIndex_updateWhenTag_'+randomId];
        }
    }, []);

    useEffect(() => {
        if (props.onTagSelected){
            props.onTagSelected(selectTag);
        }
    }, [selectTag]);


    /**
     * 刷新项目和tag
     */
    const refreshProjectAndTag = ()=>{
        getNoteList().then(res=>{
            setArrayProjectDatas(res);
        })
        updateTagList();
    }

    /**
     * 重置标签
     */
    const onResetTag = ()=>{
        setSelectTag(null);
        mSelectTag.current = '';
        props.onRefreshData('');
    }

    /**
     * 更新标签列表
     */
    const updateTagList = ()=>{
        getTagList().then(res=>{
            mArrayTags.length = 0;

            if (res.length > 0){
                mArrayTags.push({
                    value:FILTER_TAG_NO_TAGS,
                    label:t("No tags")
                })

                mArrayTags.push({
                    id:MENU_SEPARATOR,
                    value:generateUUID2()
                })
            }

            res.forEach(p=>{
                mArrayTags.push({
                    value:p.id,
                    label:p.name
                })
            })
            setArrayTags(mArrayTags);
        })
    }

    /**
     * 项目里面是否包含tag
     * @param tag
     */
    const tagIsInProject = (tag:any)=>{
        if (tag.value == FILTER_TAG_NO_TAGS || tag.id == MENU_SEPARATOR){
            return true;
        }
        return arrayProjectDatas.some(p=>p.tags?.includes(tag.label));
    }

    const forThisLine = ()=>{
        let isTags = false;
        for (let i=0;i<arrayTags.length;i++){
            isTags = arrayProjectDatas.some(p=>p.tags?.includes(arrayTags[i].label));
            if (isTags)break;
        }
        return isTags;
    }

    return<div className={'flex-row-vertical-center'} style={{margin:props.margin}}>
        {
            // selectTag &&
            // <div className={'flex-row-vertical-center'} style={{background:'var(--draw-tool-bar-selected-color)',borderRadius:'100px',height:'32px',padding:'0 10px',}}>
            //     <span>{selectTag.label}</span>
            //     <img className={'img-14 cursor-pointer'} src={getImagePathWithTheme('tag_close')} onClick={()=>{
            //         setSelectTag(null);
            //         mSelectTag.current = '';
            //         props.onRefreshData('');
            //     }}/>
            // </div>
        }

        <Dropdown overlayClassName='default-dropdown-style' overlayStyle={{minWidth: '232px'}}
                  trigger={['click']}
                  onOpenChange={(e)=>{
                      setIsTagFilterOpened(e);
                  }} open={isTagFilterOpened} dropdownRender={(menu)=>{
            return(
                <>
                    <div className={'font-family-regular'} style={{
                        overflowX: 'hidden',
                        maxHeight: '320px',
                        overflowY: 'auto',
                        display: 'flex',
                        borderRadius:'8px',
                        padding:'6px',
                        boxShadow:'var(--dialog-box-shadow)',
                        flexDirection: 'column',
                        background:'var(--dialog-dialog-background-color-2c)'
                    }}>
                        {
                            arrayTags.map(p =>
                                tagIsInProject(p)?
                                    <>
                                        {
                                            forThisLine() &&
                                            p.id == MENU_SEPARATOR &&
                                            <div key={p.value} className={'line'}
                                                 style={{margin: '4px -6px'}}></div>
                                        }
                                        {
                                            p.id !== MENU_SEPARATOR &&
                                            <div key={p.value} className={'dropdown-item'} onClick={() => {
                                                setIsTagFilterOpened(false);
                                                setSelectTag(p);//当前选择的标签

                                                if (p.value == FILTER_TAG_NO_TAGS) {
                                                    mSelectTag.current = FILTER_TAG_NO_TAGS+'-----';//没有tag的标题
                                                }else{
                                                    mSelectTag.current = p.label;
                                                }

                                                //更新列表...
                                                props.onRefreshData(mSelectTag.current);
                                            }}>
                                                    <span className={'span-single-line'} style={{
                                                        paddingLeft: '12px',
                                                        paddingRight: '12px'
                                                    }}>{(p.value == FILTER_TAG_NO_TAGS?'':'#')+p.label}</span>
                                            </div>
                                        }
                                    </>:<></>
                            )
                        }
                        {
                            arrayTags.length == 0 && //默认有个no tags 和横线....
                            <span style={{margin: '6px 12px 0px 12px'}}>{t("No tags yet")}</span>
                        }

                        <div style={{flexGrow: '1'}}></div>

                        {
                            props.from != FROM_LIBRARY &&
                            <>
                                <div className={'line'} style={{
                                    margin: '4px -6px',
                                    // background: 'var(--vertical-line-color)',
                                    flexShrink: '0'
                                }}></div>
                                {/*添加manager*/}
                                <div className={'flex-row-vertical-center cursor-pointer'}
                                     style={{padding: '6px 12px'}}
                                     onClick={() => {
                                         // dialogAllTagManagerRef.current?.onShowDialog();
                                         postMessage(EVENT_SWITCH_HOME_LIST_MENU, {name: 'tags'});
                                     }}>
                                    <img className={'img-16'} src={getImagePathWithTheme('go_to_tags')}/>
                                    <span className={'ml-8'}
                                          style={{marginTop: '1px'}}>{t("Go to tags")}</span>
                                </div>
                            </>
                        }
                    </div>
                </>
            )
        }}>
            <Button type={"text"} className="small-button hovered">
                <img className={'img-16'} src={getImagePathWithTheme('project_filter_tag.svg')}/>
            </Button>
        </Dropdown>
    </div>
})

export default ProjectTagFilter;